
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import publicApi from '@/api/public';
import api from '@/api/course';

import {
  Form,
  FormItem,
  Input,
  Button,
  Upload,
  Select,
  Option,
  InputNumber,
  Row,
  Col,
} from 'element-ui';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Button,
    Upload,
    Select,
    Option,
    InputNumber,
    Row,
    Col,
  },
})

export default class firstStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  @Prop({
    required: true,
    default: false,
  }) title!: any;

  private fileListIcon: any = [];

  private fileListImg: any = [];

  public form: any = {
    sort: 0,
  };

  public loading: boolean = false;

  private questions: any = [];

  private courseTypes: any = [];

  private diffculites: any = [];

  private knowledges: any = [];

  private userInfo: any = [];

  private works: any = [];

  private userLoading: boolean = false;

  private userId: string = '';

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    courseType: [
      { required: true, message: '请选择课程类型', trigger: 'change' },
    ],
    difficulty: [
      { required: true, message: '请选择难易度', trigger: 'change' },
    ],
    knowledge: [
      { required: true, message: '请选择知识点', trigger: 'change' },
    ],
    questionType: [
      { required: true, message: '请选择知课程类型', trigger: 'change' },
    ],
    sort: [
      { required: true, message: '请填写排序', trigger: 'change' },
    ],
  };

  mounted() {
    publicApi.getType('question').then((res: any) => {
      this.questions = res;
    });
    publicApi.getType('course').then((res: any) => {
      this.courseTypes = res.map((el: any) => ({ value: el.label, label: el.label }));
    });
    publicApi.getType('difficulty').then((res: any) => {
      this.diffculites = res;
    });
    publicApi.getType('knowledge').then((res: any) => {
      this.knowledges = res;
    });
    if (this.title.includes('修改')) {
      const {
        pid,
        stepId,
        courseType,
        difficulty,
        knowledge,
        scratchVersion,
        questionId,
        questionType,
        sort,
        content,
      } = this.oldForm;
      this.form = {
        pid,
        stepId,
        courseType,
        difficulty,
        knowledge,
        questionId,
        scratchVersion,
        questionType,
        sort,
        content,
      };
    }
    this.form.stepId = this.oldForm.stepId;
  }

  handleUser(v: string) {
    this.userLoading = true;
    if (v) {
      api.getUser(v).then((res:any) => {
        this.userLoading = false;
        this.userInfo = res.map((el:any) => ({ value: el.pid, label: el.userTitle }));
      });
    }
  }

  handleWorks(v: string) {
    api.getWorks(this.userId, v, 3).then((res:any) => {
      this.works = res.map((el:any) => ({ value: el.pid, label: el.title }));
    });
  }

  /**
   * @author liangyongmou
   * @desc 提交事件
   * @param 空
   */
  handleSubmit() {
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        result = this.form;
      }
    });
    return result;
  }
}
